var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vulnerability-report-filters gl-p-5 gl-bg-gray-10 gl-border-b-1 gl-border-b-solid gl-border-b-gray-100"},_vm._l((_vm.filters),function(filter){return _c(_vm.getComponentType(filter),{key:filter,tag:"component",on:{"filter-changed":_vm.updateFilterQuery}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }